import { Box, Grid, styled } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WsColors, WsTypography, WsButton, WsTypoVariants, WsTitleBanner } from 'wisestep-base';

import { accessDeniedNotoficationTxt } from '../../../../components/AccessControl/AccessControl';
import { ActivateFeature } from '../../../../components/ActivateFeature';
import { CandidateAtsAccess, useCandidateAts } from '../../../../hooks/useCandidateAts';
import { warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

import GetCard from './GetCard';

const BulkImportSubmission = () => {
  const titles = ['Upload CVs', 'Upload CVs', 'Upload candidates info'];
  const [params] = useSearchParams();
  const jobId = String(params.get('jobId') ?? '');

  const LayoutTheme = styled(Box)(() => ({
    maxWidth: '100%',
    maxHeight: 'xs',
    backgroundColor: WsColors.TertiaryShades50,
    padding: 2,
  }));
  const isLocalImport = useCandidateAts(CandidateAtsAccess.LOCAL_IMPORT);
  const isGdriveImport = useCandidateAts(CandidateAtsAccess.GDRIVE_IMPORT);
  const isExcelImport = useCandidateAts(CandidateAtsAccess.EXCEL_IMPORT);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const handleNavigation = {
    [0]: () =>
      isLocalImport
        ? navigate(`/import-candidates/submission/bulk-upload-to-cv-parser?jobId=${jobId}`)
        : setNotification(warning(accessDeniedNotoficationTxt)),
    [1]: () =>
      isGdriveImport
        ? navigate('/import-candidates/bulk-upload-to-cv-parser/google-drive')
        : setNotification(warning(accessDeniedNotoficationTxt)),
    [2]: () =>
      isExcelImport
        ? navigate(`/import-candidates/bulk-upload-excel?jobId=${jobId}`)
        : setNotification(warning(accessDeniedNotoficationTxt)),
  };
  const navigate = useNavigate();

  const featureCodes = ['CS_UPLOAD_AND_PARSE_CV', 'CS_UPLOAD_AND_PARSE_CV', 'CS_UPLOAD_EXCEL'];

  return (
    <LayoutTheme>
      <WsTitleBanner
        title="Import Candidates"
        goBack={() => navigate('/')}
        rightChildren={
          <WsButton
            variant="contained"
            onClick={() => navigate('/import-candidates/bulk-upload-report')}
            size="small"
          >
            Upload History
          </WsButton>
        }
      />
      <Grid container rowSpacing={2} columnSpacing={2} justifyContent="center" pt={4}>
        <Grid item xs={12} alignContent="flex-start" pb={1}>
          <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
            Pick your option to upload candidate details
          </WsTypography>
        </Grid>
        {titles.map((title, index) => (
          <>
            {index < 3 ? (
              <ActivateFeature feature={featureCodes[index]}>
                <GetCard
                  cardIndex={index}
                  cardTitle={title}
                  cardNavigation={handleNavigation}
                ></GetCard>
              </ActivateFeature>
            ) : (
              <Box>
                <GetCard
                  cardIndex={index}
                  cardTitle={title}
                  cardNavigation={handleNavigation}
                ></GetCard>
              </Box>
            )}
          </>
        ))}
      </Grid>
    </LayoutTheme>
  );
};

export default BulkImportSubmission;
